export const TREASURE_TILE_CHARGE_MS = 1000;

export const TREASURE_RARITY_COLORS = {
  Common: '#aeb7c2',
  Uncommon: '#ffffff',
  Rare: '#75c7ff',
  Epic: '#d18aff',
  Legendary: '#ffdf69',
  Special: '#ff4f64',
};
